// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d-one-line[data-v-4808a670]{clear:both;display:inline-block;overflow:hidden;white-space:nowrap}.custom-form-group[data-v-4808a670]{margin-bottom:unset}", ""]);
// Exports
module.exports = exports;
